import React, {Component, ReactNode} from "react"

import {PROPERTY} from "@irati/reward/constants/share"
import {Select} from "@irati/ui/src/FormItem"
import id from "@irati/utils/id"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {ShareOption} from "@irati/reward/types"

import ShareRow from "./shared/ShareRow"

interface Props extends InjectIntl {
  id?: string,
  label?: string,
  onChange(shareWith: ShareOption): void,
  options?: ShareOption[],
  placeholder?: string,
  shareWith: ShareOption,
  showPrivate?: boolean,
  valueRenderer?: ReactNode
}

class Share extends Component<Props> {
  static defaultProps = {
    id: "share",
    label: "reward.fields.share.placeholder",
    options: null,
    placeholder: "reward.fields.share.label",
    showPrivate: true,
    valueRenderer: ShareRow
  }

  render() {
    const {onChange, options, shareWith, ...props} = this.props

    return (
      <Select
        {...props}
        isClearable={false}
        id={id(PROPERTY, this.props)}
        name={id(PROPERTY, this.props)}
        onChange={onChange}
        options={options}
        isSearchable={false}
        value={shareWith} />
    )
  }
}
export default injectIntl(Share)
